import * as helper from './../../../Assets/Js/helper';
import {replaceSmily} from "./Smilynator";

export function ChatInput() {
	let count = 5;
	const template = `<div class="message message-client">
						<div class="message-left"></div>
						<div class="message-right">
							<div class="message-username">
								Du
							</div>
							<div class="message-bubble message-bubble-client">
								MESSAGE
							</div>
							<div class="message-period">
								gerade eben
							</div>
						</div>
					</div>`;

	const chatWindow:HTMLDivElement = document.querySelector('.model-chat-content');
	const inputHolder:HTMLDivElement = document.querySelector('.model-chat-input');
	const inputfield:HTMLInputElement = document.querySelector('.model-chat-input-write');
	const sendButton:HTMLImageElement = document.querySelector('.model-chat-input-img.send');

	function sendMessage() {
		const input = replaceSmily(inputfield.value.trim());
		if (input !== '' && count > 0) {
			const message = helper.stringToHtml(template.replace('MESSAGE', input));
			chatWindow.append(message);
			inputfield.value = '';
			count--;
			inputfield.placeholder = `Nachricht schreiben... (noch ${count} von 5)`

			if (count === 0) {
				helper.removeClass(helper.$('#chatOverlay'), 'd-none');
				helper.hide(inputHolder);
			}
		}
		chatWindow.scrollTop = chatWindow.scrollHeight;
	}

	helper.addEventListener(inputfield, 'keydown', (e:KeyboardEvent) => {
		if (e.key === 'Enter') {
			sendMessage();
			return false;
		}
	})

	helper.addClickListener(sendButton, (e:MouseEvent) => {
		e.preventDefault();
		sendMessage();
	})
}
